export default "__VITE_ASSET__DKOSsfqZ__"